// Customer portal APIs answer HTTP 200 with an application `responseCode`
// inside the body (e.g. 417 Expectation Failed, 406 Record Not Found).
// A request is successful only when BOTH are 200.
export const isApiSuccess = (res) => res?.status === 200 && res?.data?.responseCode === 200;

export const apiMessage = (res, fallback = 'Something went wrong') =>
    res?.data?.responseMessage || res?.data?.message || res?.data?.ERROR || fallback;
